import { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

export function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  const [showReconnect, setShowReconnect] = useState(false);

  useEffect(() => {
    const goOffline = () => setOnline(false);
    const goOnline = () => {
      setOnline(true);
      setShowReconnect(true);
      setTimeout(() => setShowReconnect(false), 3000);
    };
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online && !showReconnect) return null;

  return (
    <div className={`fixed top-0 left-0 right-0 z-[9999] text-center text-xs font-medium py-1.5 transition-all duration-300 ${
      online ? 'bg-emerald-500 text-white' : 'bg-red-500 text-white'
    }`} data-testid="offline-indicator">
      {online ? (
        <span className="flex items-center justify-center gap-1"><Wifi className="w-3 h-3" /> Back online</span>
      ) : (
        <span className="flex items-center justify-center gap-1"><WifiOff className="w-3 h-3" /> You're offline — actions will sync when reconnected</span>
      )}
    </div>
  );
}
